import Utils from "./utils";
import Router from "./router";
import Modal from "./modal";

export default class LoginModal extends Modal {
  #router;
  #title;
  #$container;

  constructor() {
    super();
    this.#router = new Router();
    this.#title = "Please login or register";
  }

  init() {
    this.#$container = $("#booking-modal #content-wrap");
    this.setContent(this.#title, this.#getContent());
    this.#router.init(this.#$container, true);
    this.#bindEvents();
  }

  async open() {
    await super.open();
    await this.#router.load("/Account/Login", { ReturnUrl: "/Account/LoginSuccess" });
  }

  async requestLogin() {
    await this.open();

    try {
      await this.#awaitLoginSuccess();
    } catch (error) {
      if (error.message === "Aborted") {
        error.message = "Login cancelled.";
      }

      throw error;
    } finally {
      await this.close();
    }

    // Login success
  }

  #bindEvents() {
    this.#$container.on("content-loaded", async (e, { url }) => {
      // Ignore propagated routing events, we only care about 
      // full navigation events directly triggered on our container.
      if (e.target != this.#$container[0]) {
        return;
      }

      // Consume the event so if there is more than one router
      // (e.g., another modal) they don't both fire.
      e.stopPropagation();

      this.scrollToContent();
      this.#refreshIntercepts();
    });
  }

  #refreshIntercepts() {
    this.#router.refreshIntercepts();
    this.#interceptSubmit();
  }

  #interceptSubmit() {
    let $forms = this.#$container.find("form");
    $forms.off("submit").on("submit", async (e) => {
      e.preventDefault();

      const $form = $(e.currentTarget);
      await this.#router.load($form.attr("action"), $form.serializeObject(), "POST")
    });
  }

  async #awaitLoginSuccess() {
    return Utils.promisifyEvent(document, "login-success", this.abortController.signal);
  }

  #getContent() {
    return $(`<div class="spinner d-flex justify-content-center mt-5 mb-5">
                <div class="page-spinner spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div id="content" class="row p-3"></div>`);
  }
}
